import React from 'react';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { Heading, MoreButton, ThreeColumn, useStyles } from '../SizeCard.styles';
import Common from './Common';
import Female from './Female';
import Male from './Male';
import NonBinary from './NonBinary';
import CompCardButton from '../CompCardButton';
import { Autocomplete } from '@material-ui/lab';
import { TextInput } from '@room-match/shared-ui-components';
import { Collapse } from '@material-ui/core';

interface Props {
  requiredOnly?: boolean;
  requiredFields?: string[];
  compCardAdd?: (arg0: { key: string; value: string }) => void;
  compCardRemove?: (arg: { key: string }) => void;
  form: any; // FormikProps<ITalentUpdatePayload>
  filterOptions: any;
  filteredChestOptions: any[];
  filteredWaistOptions: any[];
  filteredShoeOptions: any[];
  filteredInseamOptions: any[];
  filteredNeckOptions: any[];
  sleeveOption: any;
  filteredHatOptions: any[];
  filteredGloveOptions: any[];
  filteredBustOptions: any[];
  filteredKidShoeOptions: any[];
  setRequiredOnly?: (value: boolean) => void;
  isOpportunities?: boolean;
  gender?: string;
  metricValue?: string;
  newweight?: { im: string; metric: string; imperial: string }[];
}

const NonRequired: React.FC<Props> = ({
  requiredOnly = false,
  requiredFields = [],
  compCardAdd,
  compCardRemove,
  form,
  filterOptions,
  filteredChestOptions,
  filteredWaistOptions,
  filteredShoeOptions,
  filteredInseamOptions,
  filteredNeckOptions,
  sleeveOption,
  filteredHatOptions,
  filteredGloveOptions,
  filteredBustOptions,
  filteredKidShoeOptions,
  setRequiredOnly = () => {},
  isOpportunities = false,
  gender = '',
  metricValue = '',
  newweight = [],
}) => {
  const classes = useStyles();
  return (
    <>
      <Heading>
        Non-required sizes
        <MoreButton variant="outlined" onClick={() => setRequiredOnly(!requiredOnly)}>
          <CustomTypography fontSize={16}>{requiredOnly ? 'Show' : 'Hide'}</CustomTypography>
        </MoreButton>
      </Heading>
      <Collapse in={!requiredOnly}>
        <ThreeColumn isModal={+Boolean(isOpportunities)}>
          {!requiredOnly && !requiredFields?.includes('weight') && (
            <div>
              <CompCardButton
                onClick={compCardAdd}
                attributes={{
                  label: 'Weight',
                  key: 'weight',
                }}
                hasValue={form.values.statistics?.weight !== '' && form.values.statistics?.weight !== null}
              />
              <Autocomplete
                id="sizeCardWeight"
                filterOptions={filterOptions}
                onChange={(e, newValue, reason) => {
                  if (compCardRemove && reason === 'clear') {
                    compCardRemove({ key: 'weight' });
                  }
                  form.setFieldValue('statistics.weight', newValue);
                }}
                value={form.values.statistics?.weight}
                options={newweight.map((i) =>
                  metricValue === 'AL' ? i.im : metricValue === 'CM' ? i.metric : i.imperial,
                )}
                getOptionSelected={(option, value) => option === value}
                fullWidth
                classes={{
                  option: classes.option,
                }}
                renderInput={(params) => (
                  <TextInput
                    {...params}
                    placeholder={'Select Weight'}
                    InputProps={{
                      ...params.InputProps,
                      classes: {
                        root: classes.textInputStyle,
                      },
                    }}
                    errorMessage={
                      !form.values.statistics?.weight && form.values.country !== 'Australia' ? 'Weight is required' : ''
                    }
                  />
                )}
              />
            </div>
          )}
          {gender === 'Male' || gender === 'Trans Man' ? (
            <Male
              nonRequiredFields
              requiredOnly={requiredOnly}
              requiredFields={requiredFields}
              compCardAdd={compCardAdd}
              compCardRemove={compCardRemove}
              form={form}
              filterOptions={filterOptions}
              filteredChestOptions={filteredChestOptions}
              filteredWaistOptions={filteredWaistOptions}
            />
          ) : gender === 'Female' || gender === 'Trans Woman' ? (
            <Female
              nonRequiredFields
              requiredOnly={requiredOnly}
              requiredFields={requiredFields}
              compCardAdd={compCardAdd}
              compCardRemove={compCardRemove}
              form={form}
              filteredBustOptions={filteredBustOptions}
              filterOptions={filterOptions}
              filteredWaistOptions={filteredWaistOptions}
              metricValue={metricValue || ''}
            />
          ) : (
            <NonBinary
              nonRequiredFields
              requiredOnly={requiredOnly}
              requiredFields={requiredFields}
              compCardAdd={compCardAdd}
              compCardRemove={compCardRemove}
              form={form}
              filterOptions={filterOptions}
              filteredChestOptions={filteredChestOptions}
              filteredWaistOptions={filteredWaistOptions}
              filteredShoeOptions={filteredShoeOptions}
              filteredInseamOptions={filteredInseamOptions}
              filteredNeckOptions={filteredNeckOptions}
              sleeveOption={sleeveOption}
              filteredHatOptions={filteredHatOptions}
              filteredGloveOptions={filteredGloveOptions}
              filteredBustOptions={filteredBustOptions}
              metricValue={metricValue || ''}
            />
          )}
          <Common
            nonRequiredFields
            requiredOnly={requiredOnly}
            requiredFields={requiredFields}
            compCardAdd={compCardAdd}
            compCardRemove={compCardRemove}
            form={form}
            filterOptions={filterOptions}
            filteredShoeOptions={filteredShoeOptions}
            filteredInseamOptions={filteredInseamOptions}
            filteredNeckOptions={filteredNeckOptions}
            sleeveOption={sleeveOption}
            filteredHatOptions={filteredHatOptions}
            filteredGloveOptions={filteredGloveOptions}
            filteredBustOptions={filteredBustOptions}
            filteredKidShoeOptions={filteredKidShoeOptions}
          />
        </ThreeColumn>
      </Collapse>
    </>
  );
};

export default NonRequired;
